import { SPACE_BLOCK, SPACE_SECTION } from "../../layoutTokens";

/**
 * The two-column form grid both User Information sections share.
 *
 * Shared rather than repeated so the two sections cannot drift apart — a grid that is 2-up in one
 * section and 2-up-with-a-different-gap in the next reads as a rendering bug.
 *
 * Asymmetric gaps are deliberate and come from the prototype: 24px between columns, 16px between
 * rows. Equal gaps make the two columns read as one four-field block, because the horizontal
 * distance between a field and its neighbour matches the vertical distance to the field below it.
 */
export const FIELD_GRID = {
  columnGap: SPACE_SECTION,
  display: "grid",
  gridTemplateColumns: { md: "repeat(2, minmax(0, 1fr))", xs: "1fr" },
  marginTop: SPACE_BLOCK,
  rowGap: SPACE_BLOCK,

  /*
   * One required indicator, not two. Interstate's `required` already puts the **word** "(required)"
   * in the label, and MUI then appends its own asterisk on top — so the label read "First Name
   * (required) *", stating the same fact twice.
   *
   * The word is the one to keep: the asterisk is already `aria-hidden`, so it was never doing
   * anything for assistive technology, and a glyph alone would lean on a visual convention the word
   * states outright (FR-050). Hidden at the grid level rather than per field, so a field added later
   * cannot reintroduce it.
   */
  "& .MuiFormLabel-asterisk": { display: "none" }
};

/**
 * Spans a field across the whole grid, for the ones the prototype gives their own row: Title,
 * Company, and both email addresses.
 *
 * `1 / -1` — first grid line to last — rather than a breakpoint-conditional span, because at `xs`
 * the grid is already a single column, where first-to-last is exactly that one column. So the same
 * value is correct at both breakpoints and the rule needs no `md` variant of its own.
 */
export const FULL_WIDTH_FIELD = { gridColumn: "1 / -1" };
